import React, { Component } from 'react';
import { ThemeColor } from '@qnpm/q-theme';
import { StyleSheet, Image, View, TouchableOpacity, Text } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';
import { toJS } from 'mobx';
import Icon from './Icon';
import Passengers from './passengersPopLayer';

const isIOS = DeviceInfo.isIOS;
export default class ProductPopLayer extends Component<any, any> {

    constructor(props: any) {
        super(props);
    }

    /**
     * place the element of index into the first place.
     * @param array 
     * @param index 
     */
    changeArray(array: [], index: number): [] {
        if (!index) {
            return array;
        }
        const newArray = JSON.parse(JSON.stringify(array));
        const element = newArray[index];
        // delete the element of index.
        newArray.splice(index, 1);
        // put the element in the first.
        newArray.unshift(element);
        return newArray;
    }

    render() {
        const { marketing, productIndex, setMarketing } = this.props || {};
        const { clearProductInfoList = [], productInfoListVisible = [], formData = {} } = marketing || {};
        if (!clearProductInfoList || !clearProductInfoList.length) {
            return null;
        }

        const productList = this.changeArray(clearProductInfoList, productIndex);

        return (
            productList.map((item, idx) => {

                let { productName = '', price, originPrice, passgenerInfoList = [],
                    privilegeExplains = [], useExplains = [], useDetailUrl, cardNoShow, productType } = item || {};
                let privilegeExplainsLen = privilegeExplains &&
                    Array.isArray(toJS(privilegeExplains)) && privilegeExplains.length;
                let useExplainsLen = useExplains && Array.isArray(toJS(useExplains)) && useExplains.length;

                const visible = productInfoListVisible[idx];

                return (
                    <View style={styles.productBox} key={idx}>
                        {/* 产品 */}
                        <View style={styles.product}>
                            {/* 名称 */}
                            <View style={styles.productName}>
                                <Text style={styles.title}>{productName}</Text>
                                <View style={styles.priceBox}>
                                    <Text style={styles.price}>&yen;{price}</Text><Text style={styles.num}>/份</Text>
                                    <Text style={styles.lineThrough}>&yen;{originPrice}</Text>
                                </View>

                            </View>

                            <Passengers data={passgenerInfoList} formData={formData} idx={idx} productType={productType} marketing={marketing} setMarketing={setMarketing} />
                            {
                                cardNoShow ?
                                    <Text style={styles.idNumber}>
                                        使用人证件号：{cardNoShow}
                                    </Text>
                                    : null
                            }

                        </View>
                        {
                            visible ?

                                <View style={styles.explain}>
                                    {/* 特权说明 */}
                                    <View>
                                        <View style={styles.label}>
                                            <Text style={styles.labelIconLine} />
                                            <Text style={styles.labelName}>特权说明</Text>
                                        </View>
                                        <View style={styles.desc}>
                                            {
                                                privilegeExplainsLen > 0 ?
                                                    privilegeExplains.map((item, j) => {
                                                        return (
                                                            <View style={styles.descRow} key={j}>
                                                                {/* <View style={styles.descDotBox}>
                                                                    <Text style={styles.descDot} />
                                                                </View> */}
                                                                <Text style={styles.descInfo}>{item}</Text>
                                                            </View>
                                                        );
                                                    })
                                                    : null
                                            }
                                        </View>
                                    </View>
                                    {/* 使用说明 */}
                                    <View>
                                        <View style={styles.label}>
                                            <Text style={styles.labelIconLine} />
                                            <Text style={styles.labelName}>使用说明</Text>
                                        </View>
                                        <View style={styles.desc}>
                                            {
                                                useExplainsLen > 0 ?
                                                    useExplains.map((item, j) => {
                                                        return (
                                                            <View style={styles.descRow} key={j}>
                                                                {/* <View style={styles.descDotBox}>
                                                                    <Text style={styles.descDot} />
                                                                </View> */}
                                                                <Text style={styles.descInfo}>{item}</Text>
                                                            </View>
                                                        );
                                                    })
                                                    : null
                                            }
                                            {
                                                useDetailUrl ?
                                                    <Image style={styles.img} source={{ uri: useDetailUrl }} />
                                                    : null
                                            }
                                        </View>
                                    </View>
                                </View>
                                : null

                        }
                        {
                            this.renderIcon(visible, idx, productType)
                        }
                    </View>
                );
            })
        );
    }

    show(idx: number) {
        const { marketing, setMarketing } = this.props;
        const { productInfoListVisible = [] } = marketing || {};
        productInfoListVisible[idx] = !productInfoListVisible[idx];
        setMarketing(marketing);
    }

    renderIcon(visible: boolean, idx: number, productType?: string) {

        let icon = visible ? 'newup' : 'newdown';

        return (
            <TouchableOpacity onPress={() => {
                this.show(idx);

            }} style={styles.detailText}>
                <Text style={styles.toggleBtn}>{visible ? '收起' : '查看特权详情'}</Text>
                <Text style={{ backgroundColor: 'transparent', paddingTop: 2 }}>
                    <Icon name={icon} size={11} color="#999" />
                </Text>
            </TouchableOpacity>
        );
    }
}

const styles = StyleSheet.create({
    // 产品乘机人
    productBox: {

    },
    product: {
        backgroundColor: '#F0F3F5',
        borderRadius: 8,
        paddingHorizontal: 12,
        paddingTop: 13,
        paddingBottom: 5,
        marginBottom: 16,
        marginHorizontal: 24
    },
    productName: {
        flexDirection: 'row',
        paddingLeft: 4,
        marginBottom: 12
    },
    title: {
        fontSize: 16,
        lineHeight: 22,
        color: '#333',
        fontWeight: 'bold',
        alignSelf: 'flex-end'
    },
    priceBox: {
        marginLeft: 10,
        flexDirection: 'row',
        alignSelf: 'flex-end'
    },
    price: {
        fontFamily: 'PingFangSC-Semibold',
        color: '#FF6600',
        fontSize: 12,
        lineHeight: 22,
        letterSpacing: -1,
        marginBottom: -2
    },
    lineThrough: {
        marginLeft: 5,
        textDecorationLine: 'line-through',
        fontSize: 12,
        lineHeight: 22,
        color: '#9E9E9E'
    },
    num: {
        fontSize: 12,
        lineHeight: 22,
        color: '#9E9E9E'
    },
    idNumber: {
        // backgroundColor: 'red',
        paddingLeft: 4,
        paddingTop: 4,
        paddingBottom: 8,
        fontSize: 12,
        lineHeight: 17,
        color: ThemeColor.text2
    },

    // 使用说明
    explain: {

    },
    label: {
        paddingLeft: 43,
        flexDirection: 'row',
        marginBottom: 11,
        alignItems: 'center'
    },
    labelIconLine: {
        height: 10,
        width: 3,
        borderRadius: 1.5,
        backgroundColor: '#666',
        marginRight: 8,
        overflow: 'hidden'
    },
    labelName: {
        fontSize: 14,
        color: '#333'
    },
    desc: {
        backgroundColor: '#F7F9FA',
        paddingHorizontal: 16,
        paddingVertical: 12,
        marginHorizontal: 32,
        marginBottom: 16,
        borderRadius: 8
    },
    descRow: {
        flexDirection: 'row',
        alignItems: 'stretch',
        marginBottom: 3
        // backgroundColor: 'yellow'
    },
    descDotBox: {
        // backgroundColor: 'red',
        marginRight: 6
    },
    descDot: {
        backgroundColor: '#666',
        borderRadius: 5,
        width: 2,
        height: 2,
        marginTop: 8,
        lineHeight: 17
    },
    descInfo: {
        flex: 1,
        color: '#666',
        fontSize: 12,
        lineHeight: 17
    },
    img: {
        marginTop: 9,
        width: '100%',
        height: 44
    },
    // 查看展开收起
    detailText: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: -8,
        marginBottom: 25,
        paddingRight: 32
    },
    toggleBtn: {
        color: '#333',
        fontWeight: 'bold',
        marginRight: 3,
        fontSize: 11
    }
});
